import { FilterConditionOutput } from '@components/ui/AdvancedFilter';
import { AgGridTableProps } from '@shared/components/ui/AgGridTable';
import { useMemo } from 'react';
import { mapFilterConditionToApiFilter } from './ordersWithoutWeightFilterConditionMapper';

type SortingConfig = NonNullable<AgGridTableProps['sorting']>;

export const useProcessedFilters = (filterConditions: FilterConditionOutput[], sorting: SortingConfig | null) => {
  return useMemo(() => {
    const advancedFilters = {
      filters: [] as Array<{
        column: string;
        operator: string;
        value: string | string[] | number | number[] | boolean | null;
      }>,
      logic: 'AND' as 'AND' | 'OR',
    };

    filterConditions.forEach((condition) => {
      advancedFilters.filters.push(mapFilterConditionToApiFilter(condition));
    });

    const sortingColumnMap: Record<string, string> = {
      id: 'id',
      ref: 'ref',
      created_at: 'order_created_at',
      processed_at: 'processed_at',
      last_shipment_update: 'last_shipment_update',
    };

    const sortingField = sorting?.field || 'id';
    const apiSortingColumn = sortingColumnMap[sortingField] || sortingColumnMap['id'];

    return {
      ...(advancedFilters.filters.length > 0
        ? {
            advanced_filters: advancedFilters,
          }
        : {}),
      sorting: {
        column: apiSortingColumn as 'id' | 'ref' | 'order_created_at' | 'processed_at' | 'last_shipment_update',
        direction: (sorting?.direction ?? 'asc') as 'asc' | 'desc',
      },
    };
  }, [filterConditions, sorting]);
};
